var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505 2375 c-24 -23 -25 -29 -25 -160 l0 -135 240 0 240 0 0 135 c0 131 -1 137 -25 160 -24 25 -26 25 -215 25 -189 0 -191 0 -215 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625 2375 c-24 -23 -25 -29 -25 -160 l0 -135 240 0 240 0 0 135 c0 131 -1 137 -25 160 -24 25 -26 25 -215 25 -189 0 -191 0 -215 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414 1906 c-17 -8 -44 -30 -59 -50 -23 -30 -29 -51 -36 -129 -16 -169 -43 -259 -136 -462 -83 -181 -127 -308 -155 -448 -19 -95 -22 -146 -22 -334 -1 -208 0 -223 20 -249 11 -15 33 -37 48 -48 26 -20 40 -21 326 -21 286 0 300 1 326 21 15 11 37 33 48 48 20 27 21 41 24 457 l3 429 79 0 80 0 0 400 0 400 -257 0 c-195 -1 -266 -4 -289 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120 1520 l0 -400 160 0 160 0 0 400 0 400 -160 0 -160 0 0 -400z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600 1520 l0 -400 80 0 79 0 3 -429 c3 -416 4 -430 24 -457 11 -15 33 -37 48 -48 26 -20 40 -21 326 -21 286 0 300 1 326 21 68 51 69 54 68 292 0 326 -29 456 -169 768 -108 240 -124 298 -149 537 -5 47 -48 105 -92 123 -26 11 -93 14 -289 14 l-255 0 0 -400z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.6faa75855e71355749360057adf5fc70.svg";
export { ForwardRef as ReactComponent };